import script from "./TransactionInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./TransactionInfo.vue?vue&type=script&setup=true&lang=js"

import "./TransactionInfo.vue?vue&type=style&index=0&id=a0a73e6e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0a73e6e"]])

export default __exports__